import { nanoid } from 'nanoid'
import React, { Component } from 'react'
import FixedView from '../../components/FixedView'
import { checkTranslation, conditionalWidth, translate } from '../../utils/useful'
import EmailToolbar from '../../components/header/EmailToolbar'
import ActionButton from '../../components/partials/ActionButton'
import IntractionActionsList from '../../components/IntractionActionsList'
import ButtonAnimated from '../../components/buttons/ButtonAnimated'
import importedIcons from '../../components/inputs/icons'
import HttpServices from '../../utils/Http.services'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../stores/actionsList';
import CustomLoader from '../../components/CustomLoader'
import Pagination from '../../components/Pagination'
import moment from 'jalali-moment'



class EmailList extends Component {
    state = {
        email: [
        ],
        limit: 20,
        skip: 0,
        currentPage: 0,
        selected: {},
        mailBox: {},
        archived: [],
        select: true,
        selectOption: [
            { name: 'All' },
            { name: 'None' }
        ],
        more: true,
        list: 'inbox',
        starred: false,
        moreItems: [
            { key: 'delete', img: "/assets/icons/email/trash-black.svg", name: translate('mail.Delete') },
            { key: 'star', img: "/assets/icons/email/star-empty.svg", name: translate('mail.Star') },
            { key: 'refresh', img: "/assets/icons/email/refresh-black.svg", name: translate('mail.Refresh') },
            { key: 'select', img: "/assets/icons/email/checklist-black.svg", name: translate('mail.Select') },
        ],
        type: [
            { type: 'inbox' },
            { type: 'stared' },
            { type: 'snoozed' },
            { type: 'sent' },
            { type: 'draft' },
            { type: 'important' },
            { type: 'scheduled' },
            { type: 'all' },
            { type: 'spam' },
            { type: 'deleted' },
            { type: 'archive' },

            // { type: 'star' },
            // { type: 'schedule' }
        ],


        actions: {
            // done: { key: "done", label: '{{lang}}Mark as done', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: this.openEditModal },

            edit: { key: "edit", label: '{{lang}}View / Edit', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: this.openEditModal },
            changeStage: { key: "changeStage", label: '{{lang}}Change Stage', sub: true, color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: this.changeRecordStageModal },


            request: { key: "request", label: '{{lang}}Request', color: '#000', sub: true, bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: this.openEditModal },
            extra: { key: "extra", label: '{{lang}}Extra', color: '#000', sub: true, bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: this.openEditModal },


            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', borderTop: '1px solid #eee', icon: '/assets/icons/useful/trash-o.svg', function: this.openRemoveModal },

            duplicate: { key: "duplicate", label: '{{lang}}Duplicate', color: '#000', icon: '/assets/icons/useful/duplicate.svg', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: this.openEditModal },
            share: { key: "share", label: '{{lang}}Share', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: this.openEditModal },
            activityLogs: { key: "activityLogs", label: '{{lang}}Activity Logs', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: this.getActivityLogs },

        },
        selectMode: false
    }



    componentDidMount = () => {
        // let email = this.state.email
        // let mailBox = this.state.mailBox
        // let type = this.state.type
        // email.forEach((item) => {
        //     if (!mailBox[item.type]) {
        //         mailBox[item.type] = []
        //     }
        //     mailBox[item.type].push(item)
        // })
        // // console.log('mailBox', mailBox)
        // type.forEach(item => {
        //     if (!mailBox[item.type]) {
        //         mailBox[item.type] = []
        //     }
        // });
        // this.setState({ mailBox })
        this.fetchData()


        if (this.props.setHeader) {


            this.props.setHeader({
                'toolbar': this.toolbarView,
                'showToolbar': true,
                // 'title': this.props.page?.title,
                // 'subtitle': this.props.page?.subtitle,

            })
        }
    }
    componentDidUpdate(prevProps) {
        // console.log('this.props', this.props)
        if (this.props.page?._id && JSON.stringify(this.props.page?._id) != JSON.stringify(prevProps.page?._id)) {

            this.fetchData()
        }
    }
    fetchData = (filter, getCount) => {
        if (this.props.page) {

            let body = {
                filter: { email: this.props.page._id }
            }
            body.limit = this.state.limit
            body.skip = this.state.currentPage
            // let page = this.props.page
            // console.log('*getMails')
            this.setState({ isLoadingData: true })
            if (this.state.totalCount == null || getCount) {
                body.getCount = true
            }
            HttpServices.request('getMails', body, (fetchResult, fetchError) => {

                // console.log(fetchResult, fetchError)
                this.setState({ isLoadingData: false })
                // console.log('tp1')
                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }
                // let mailBox = this.state.mailBox
                // let list = this.state.list
                // mailBox[list] = fetchResult.info
                let email = fetchResult.info ?? []
                // console.log('tp2')

                this.setState({ data: fetchResult.info, email }, () => {
                })
                setTimeout(() => {
                    // console.log('tp3', this.state)
                }, 5000);

                // console.log('tp4')
                if (fetchResult.count != null) {
                    this.setState({ totalCount: fetchResult.count })
                }
            })
        }
    }

    toolbarView = () => {
        return (
            <EmailToolbar functionsHandler={this.toolbarFunctionsHandler} selectMode={this.state.selectMode} toggleSelectMode={this.toggleSelectMode} sections={this.props.sections} modules={this.props.modules} changePage={this.props.changePage} color={this.props.color} colors={this.props.colors} language={this.props.language} width={this.props.width} SelectAllMail={this.SelectAllMail} />
        )
    }

    toolbarFunctionsHandler = (type, name, data) => {
        console.log('functionsHandler2', type, name, data)

        if (this[name]) {
            this[name](data)
        }
    }

    toggleSelectMode = () => {
        this.setState({ selectMode: !this.state.selectMode }, () => {
            this.props.setHeader('dummy', 1)
        })
    }




    selectMail = (prop) => {
        let checkBox = this.state.selectMode
        let selected = this.state.selected
        // console.log('Selected==> **', selected)
        // console.log('Selected==>', Object.values(selected))
        // console.log('Selected==>check', checkBox)
        if (selected[prop._id] == true) {
            selected[prop._id] = false
        }
        else {
            selected[prop._id] = true
        }
        if (Object.values(selected).length == 0) {
            checkBox = false
        }
        else {
            checkBox = true
        }
        this.setState({ selected })
        if (this.state.selectMode != checkBox) {
            this.setState({ checkBox })
        }
    }

    SelectAllMail = (key) => {
        let checkBox = this.state.selectMode
        let selected = this.state.selected
        for (let i = 0; i < this.state.mailBox[this.props.currentTab].length; i++) {
            const prop = this.state.mailBox[this.props.currentTab][i];
            if (key == 'All') {
                selected[prop._id] = true

                checkBox = true
            }

            if (key == 'None') {
                selected[prop._id] = false
                checkBox = false
            }
            this.setState({ selected })
            if (this.state.selectMode != checkBox) {
                this.setState({ checkBox })
            }
        }
    }

    mailBoxChange = (list) => {
        let mailBox = this.state.mailBox
        let email = this.state.email
        this.setState({ list }, () => {
            email.forEach(mail => {
                if (mail.type == list)
                    mailBox[list].push(mail)
            });
            this.setState({ mailBox })
        })
    }

    // mailBoxChange = (list) => {
    //     let mailBox = this.state.mailBox
    //     this.setState({ list }, () => {
    //         if (list == 'inbox') {
    //             mailBox.push(this.state.email)
    //         }
    //         if (list == 'archived') {
    //             mailBox.push(this.state.archived)
    //         }
    //         if (list == 'deleted') {
    //             mailBox.push(this.state.deleted)
    //         }
    //         this.setState({ mailBox })
    //     })
    // }

    archiveMail = (index) => {
        if (this.state.currentTab == 'inbox') {
            let mailBox = this.state.mailBox

            mailBox.archive.push(mailBox.inbox[index])
            console.log('mailBox.archive', mailBox.inbox[index])
            mailBox.inbox.splice(index, 1)
            console.log('mailBox.archive', mailBox.archive)
            this.setState({ mailBox })
        }
    }

    deleteMail = (index) => {
        if (this.state.currentTab == 'inbox') {
            let mailBox = this.state.mailBox

            mailBox.deleted.push(mailBox.inbox[index])
            mailBox.inbox.splice(index, 1)
            this.setState({ mailBox })
        }
    }

    fixedViewSet = () => {
        let select = this.state.select
        this.setState({ select: !select })
        if (select == true) {
            this.fixedView.showView()
        }
        else {
            this.fixedView.hideView()
        }
    }



    moreFixedViewSet = () => {
        let more = this.state.more
        this.setState({ more: !more })
        if (more == true) {
            this.moreFixedView.showView()
        }
        else {
            this.moreFixedView.hideView()
        }
    }

    showSelectView = () => {
        this.fixedView.showView()
    }

    setStar = (id) => {
        // let email = this.state.email
        let body = { email: id }
        HttpServices.request('starMail', body, (fetchResult, fetchError) => {

            if (fetchError) {
                return
            }
            let email = this.state.email

            email.forEach((item, index) => {
                if (fetchResult.info?._id == item._id) {
                    email[index] = fetchResult.info
                }

            })
            this.setState({ email })
            // email.forEach(item => {
            //     if (item._id == id) {
            //         item.star = !item.star
            //         this.setState({ email })
            //     }
            // });

        })

    }

    openEmail = (prop) => {
        this.props.changePage([this.props.page._id, prop._id])
    }
    changePagination = (index) => {
        this.setState({ currentPage: index }, () => {
            this.fetchData(null, true)
        })
    }
    render() {
        // console.log('cccccccccccccccccc', this.state.isLoadingData)
        return (
            <div className="h-100  w-100  scroll-no-scrollbar" style={{ paddingBottom: 60 }}>
                {/* {Array.isArray(this.state.mailBox[this.state.list]) && this.state.mailBox[this.state.list]?.map((prop, index) => { */}
                {!this.state.isLoadingData ? (
                    <div>

                        {this.state.email?.map((prop, index) => {
                            let reg = /^(.+?)\s*<(.+?)>$/
                            const match = prop.from[0]?.match(reg);
                            let addressinfo = { email: '', name: '' }
                            if (match) {
                                addressinfo.name = match[1]
                                addressinfo.email = match[2]
                            }
                            const dateObj = moment(prop.date);
                            // console.log('dateObj', dateObj)
                            const date = dateObj.format("DD MMM YYYY");
                            const time = dateObj.format("HH:mm:ss");
                            // console.log('time', time)
                            return (
                                <div className='flexcb w-100 py-1 email-hover' style={{ backgroundColor: !prop.seen ? null : '#f8f8f8', borderBottom: '1px solid #f4f4f4' }}>
                                    <div className='flexcb pld-2 prd-4 w-100 py-2' onClick={() => { if (this.state.selectMode) { this.selectMail(prop) } else { this.openEmail(prop) } }}>
                                        <div className='flexc' style={{ width: 'calc(100% - 134px)' }}>
                                            <div className='flexc'>

                                                {this.state.selectMode ? (
                                                    <>
                                                        <button className='mrd-2 pld-2 ' >
                                                            <img width={20} className='flexcc' src={this.state.selected[prop._id] ? '/assets/icons/email/check-fill.svg' : '/assets/icons/email/check.svg'} />
                                                        </button>
                                                    </>
                                                ) : (

                                                    <div className='mrd-2 pld-2 flexcc position-relative' style={{}}>
                                                        {!prop.seen && (
                                                            <div className='mrd-2 br-20 ' style={{ position: 'absolute', pointerEvents: 'none', top: 0, left: 6, height: 6, width: 6, backgroundColor: '#007aff' }}>
                                                            </div>
                                                        )}

                                                        <ActionButton ref={el => this.actionsButton = el} onOpen={() => this.setState({ actionIsOpen: true })} onClose={() => { this.setState({ actionIsOpen: false }) }}>
                                                            <div className=" px-1 py-1  d-flex flex-column w-100 " style={{ minWidth: 190, boxShadow: '0px 0px 30px #10101030', backgroundColor: '#fff', borderRadius: 6 }}>
                                                                <div className='sc-gray2 py-1 px-1  w-100' style={{ maxHeight: 250, overflow: 'auto', }}>

                                                                    {this.state.actions && Object.values(this.state.actions).map((prop, index) => {
                                                                        return (

                                                                            <IntractionActionsList onClick={(e) => { e.stopPropagation(); this.actionClicked(prop, this.props.data, this.props.index) }} language={this.props.language} data={{ title: prop.label, sub: prop.sub, shortcut: null, icon: "/assets/icons/note/file/open.svg" }} />
                                                                            // <IntractionActionsList onClick={() => this.actionClicked(prop, this.props.data, this.props.index)} language={this.props.language} data={{ title: prop.label, sub: prop.sub, shortcut: null, icon: importedIcons['inbox'] }} />

                                                                        )
                                                                    })}


                                                                </div>

                                                            </div>
                                                        </ActionButton>
                                                    </div>
                                                    // <button className="gray-filter mrd-2">
                                                    //     <img width={20} className='flexcc' src='/assets/icons/email/action-blue.svg' />
                                                    // </button>
                                                )}

                                            </div>
                                            <div className='flexc w-100 cursor-pointer'>
                                                {/* <div className='mrd-3'>
                                            <img className='flexcc br-50' width={40} src={prop.img} />
                                        </div> */}
                                                <div className='w-100'>
                                                    <p className={'font-size-14 main-c2 flexc ' + (!prop.seen ? 'text-semibold' : '')} style={{ color: !prop.seen ? '#000' : '#666' }}>{addressinfo.name} - <span className=' mld-1'>{prop.subject[0]}</span></p>
                                                    <p className='w-100  font-size-12 main-c5 opacity-7' style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                                        {/* {checkTranslation(prop.title)} */}
                                                        <span className='   ' >{checkTranslation(prop.des)}</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={conditionalWidth(this.props.width, { xs: 'd-none', sm: 'd-none', md: 'flexcc flex-column' })}>
                                            <button className='flexcc' style={{}} onClick={(e) => { e.stopPropagation(); this.setStar(prop._id) }}>
                                                {prop.starred
                                                    ?
                                                    <img width={14} src='/assets/icons/email/star-fill.svg' />
                                                    :
                                                    <img width={14} src='/assets/icons/email/star-gray.svg' />
                                                }
                                            </button>
                                            <p className={'text-center font-size-10 mt-2 ' + (!prop.seen ? 'text-semibold' : '')} style={{ color: !prop.seen ? "#000" : '#777' }}>{time}</p>
                                        </div>
                                        <div className={conditionalWidth(this.props.width, { xs: 'flexcc flex-column', sm: 'flexcc flex-column', md: 'd-none' })}>
                                            <button className='flexcc'>
                                                <img width={20} src='/assets/icons/arrow-right-gray.svg' />
                                            </button>
                                            <p className='text-center font-size-10 mt-2' style={{ color: '#777' }}>{time}</p>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                        <div className="w-100 pt-2">
                            <Pagination currentPage={this.state.currentPage} totalCount={this.state.totalCount} limit={this.state.limit} changePage={this.changePagination} colors={this.props.colors} />
                        </div>
                    </div>
                ) :
                    <div className='h-100 w-100 flexcc'>
                        <CustomLoader isLoading={true} />
                    </div>
                }

                <div className={"position-absolute"} style={{ bottom: '10px', right: 10 }}>
                    <ButtonAnimated
                        iconwidth='24px'
                        onClick={() => this.props.changePage([this.props.page._id, "new"])}
                        title='New Email'
                        icon='/assets/icons/plus-white.svg'
                        textColor={this.props.colors?.textColor}
                        invert={this.props.colors?.iconInvert}
                        bg={this.props.colors?.background}
                    />
                </div>


                {/* <div className='' style={{ position: 'absolute', bottom: 20, right: 20, zIndex: 10 }}>
                    <button className='flexc blue-btn py-2 pld-3 prd-4 br-10' onClick={() => this.props.changePage("new")}>
                        <img width={18} src='/assets/icons/plus-white.svg' className='mrd-3' />
                        <p className='white font-size-14'>New Mail</p>
                    </button>
                </div> */}
            </div>
            // <div className='h-100 w-100'>
            //     <div className=''>
            //         <div className='w-100'>
            //             {this.state.mailBox[this.props.currentTab]?.map((prop, index) => {
            //                 return (
            //                     <div className='bb-gray w-100' >
            //                         <div className='flexc w-100' key={index}>
            //                             <div className='flexc py-2 w-100 text-start hover-gray2 br-5  pld-3 prd-4' >
            //                                 <div className='flexcb w-100' style={{}}>
            //                                     <div className='flexc w-100' style={{}}>
            //                                         <div className='flexc'>
            //                                             <div>
            //                                                 <img className='flexcc' src={prop.state} />
            //                                             </div>
            //                                             {this.state.selectMode ? (
            //                                                 <>
            //                                                     {!this.state.selected[prop._id] ? (
            //                                                         <button onClick={() => this.selectMail(prop)} className="px-2 flexc" style={{}}>
            //                                                             < img src='/assets/icons/email/check.svg' style={{ width: 20, height: 20 }} />
            //                                                         </button>
            //                                                     ) : (
            //                                                         <button onClick={() => this.selectMail(prop)} className="px-2 flexc" style={{}}>
            //                                                             < img src='/assets/icons/email/check-fill.svg' style={{ width: 20, height: 20 }} />
            //                                                         </button>
            //                                                     )}

            //                                                 </>
            //                                             ) : (
            //                                                 <button className="px-2 flexc gray-filter" style={{}}>
            //                                                     <img src='/assets/icons/email/action-blue.svg' style={{ width: 20, height: 20 }} />
            //                                                 </button>
            //                                             )}
            //                                         </div>
            //                                         <div className='flexc text-start w-100' onClick={() => this.props.changePage("single")}>
            //                                             <div className={conditionalWidth(this.props.width, { xs: 'd-none', sm: 'd-block', md: 'd-block', lg: "d-block", xl: "d-block" })}>
            //                                                 <img className='flexcc' width={40} src={prop.img} style={{ border: '1px solid #ddd', borderRadius: 100 }} />
            //                                             </div>
            //                                             <div className='pld-2 w-100'>
            //                                                 <div className='pb-1 w-100' style={{}}>
            //                                                     <p className={conditionalWidth(this.props.width, { xs: 'font-size-10', sm: 'font-size-12', md: 'font-size-12', lg: "font-size-12", xl: "font-size-12" })} style={{ color: '#222', textOverflow: 'ellipsis', overflow: 'hidden', width: '50%', whiteSpace: 'nowrap' }}>{checkTranslation(prop.user)}</p>
            //                                                     <p className={conditionalWidth(this.props.width, { xs: 'font-size-12', sm: 'font-size-14', md: 'font-size-14', lg: "font-size-14", xl: "font-size-14" })} style={{ color: '#222', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', whiteSpace: 'nowrap' }}>{checkTranslation(prop.title)}</p>
            //                                                 </div>
            //                                                 <div className='flex-1'>
            //                                                     <p className='font-size-10 gray-400 ' style={{ textOverflow: 'ellipsis', overflow: 'hidden', flex: 1, whiteSpace: 'nowrap' }}>{checkTranslation(prop.des)}</p>
            //                                                 </div>
            //                                             </div>
            //                                         </div>

            //                                         <div className='flexc'>
            //                                             <p className={conditionalWidth(this.props.width, { xs: 'font-size-8 mrd-3', sm: 'font-size-10 mrd-3', md: 'font-size-10 mrd-3', lg: "font-size-10 mrd-3", xl: "font-size-10 mrd-3" })} style={{ color: '#4F5B67' }}>{checkTranslation(prop.time)}</p>
            //                                             <button className='flexc' style={{}} onClick={() => { this.setStar(prop._id) }}>
            //                                                 {prop.star == true
            //                                                     ?
            //                                                     <img width={20} src='/assets/icons/email/star-fill.svg' />
            //                                                     :
            //                                                     <img width={20} src='/assets/icons/email/star-gray.svg' />
            //                                                 }
            //                                             </button>
            //                                         </div>
            //                                     </div>

            //                                 </div>
            //                             </div>
            //                         </div>
            //                     </div>
            //                 )
            //             })
            //             }
            //         </div >
            //     </div >
            //     <div className='' style={{ position: 'absolute', bottom: 20, right: 20, zIndex: 10 }}>
            //         <button className='flexc blue-btn py-2 pld-3 prd-4 br-10' onClick={() => this.props.changePage("new")}>
            //             <img width={18} src='/assets/icons/plus-white.svg' className='mrd-3' />
            //             <p className='white font-size-14'>New Mail</p>
            //         </button>
            //     </div>
            //     <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} showFocus={false} xOffset={conditionalWidth(this.props.width, { xs: !this.state.more ? 69 : 0, sm: !this.state.more ? 69 : 0, md: 0, lg: 0, xl: 0 })} topOffset={conditionalWidth(this.props.width, { xs: !this.state.more ? -34 : -8, sm: !this.state.more ? -34 : -8, md: -8, lg: -8, xl: -8 })} width={133} zIndex={20}>
            //         <div className='shadow-2 py-2 br-10' style={{ backgroundColor: "#fff", width: "max-Content" }}>
            //             {this.state.selectOption.map((prop, index) => {
            //                 return (
            //                     <div className="blur-back flexc flex-column hover-fields cursor-pointer px-3 py-1" style={{ alignItems: "flex-start", borderBottom: index < this.state.selectOption.length - 1 ? '1px solid rgb(242, 242, 242)' : '0px' }} onClick={() => this.SelectAllMail(prop.name)}>
            //                         <p className='font-size-12'>{checkTranslation(prop.name)}</p>
            //                     </div>
            //                 )

            //             })}
            //         </div>
            //     </FixedView>
            // </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, connections: state.connections })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(EmailList);